<template>
    <div class="filterSummary">
        <div class="row1">
            <div class="where">
                <h2>Where</h2>
                <div
                    v-text="whereText || 'All towns'"
                    :class="{notSet: !whereText}"
                    @click="showForm"
                />
            </div>
            <div class="when">
                <h2>When</h2>
                <div
                    v-text="whenText || 'Any dates'"
                    :class="{notSet: !whenText}"
                    @click="showForm"
                />
            </div>
            <div class="who">
                <h2>Who</h2>
                <div
                    v-text="whoText || 'Any party size'"
                    :class="{notSet: !whoText}"
                    @click="showForm"
                />
            </div>
        </div>
        <div class="row2">
            <div class="filters" @click="showForm">
                Filters ({{ nFilters }})
            </div>
            <div class="price" @click="showForm">
                {{ priceText }}
            </div>
            <div class="bedsBaths" @click="showForm">
                {{ bedsBathsText }}
            </div>
            <input
                class="keywords"
                v-model="keywordsText"
                placeholder="Keyword search"
                readonly
                @click="showForm"
            >
        </div>
        <div class="row3">
            <div class="propertyCount" v-text="propertyCountText" />
        </div>
    </div>
</template>

<script>
import {formatDateRange} from '../../../_components/formatDateRange';

export default {
    props: {
        criteria: {
            type: Object,
            required: true,
        },
        towns: {
            type: Array,
            default: () => [],
        },
        nResults: {
            type: Number,
        },
    },
    computed: {
        whereText() {
            let townName = '';
            if (Array.isArray(this.criteria.towns) && this.criteria.towns.length > 0) {
                townName = this.towns.find(town => town.slug === this.criteria.towns[0]).name;
                if (this.criteria.towns.length > 1) {
                    townName += ' +' + (this.criteria.towns.length - 1) + ' more';
                }
            }
            return townName;
        },
        whenText() {
            // dates_type: specific, flexible, any
            if (this.criteria.dates_type === 'specific' && this.criteria.date_in && this.criteria.date_out) {
                return formatDateRange(this.criteria.date_in, this.criteria.date_out);
            }
            if (this.criteria.dates_type === 'flexible' && this.criteria.n_days && this.criteria.date_earliest && this.criteria.date_latest) {
                return this.criteria.n_days + ' days, sometime between ' + formatDateRange(this.criteria.date_earliest, this.criteria.date_latest);
            }
            return 'Any dates';
        },
        whoText() {
            return (this.criteria.n_people > 0)
                ? (this.criteria.n_people + ' guest' + (this.criteria.n_people > 1 ? 's' : ''))
                : ''
            ;
        },
        nFilters() {
            let nFilters = 0;
            if (!!this.criteria.pets) {
                nFilters++;
            }
            if (!!this.criteria.smoking) {
                nFilters++;
            }
            if (Array.isArray(this.criteria.locales) && this.criteria.locales.length) {
                nFilters++;
            }
            if (Array.isArray(this.criteria.amenities) && this.criteria.amenities.length) {
                nFilters++;
            }
            return nFilters;
        },
        priceText() {
            let text = '';
            if (this.criteria.rate_min || this.criteria.rate_max) {
                if (this.criteria.rate_min) {
                    text += '$' + Number(this.criteria.rate_min).toFixed(0).toLocaleString();
                } else {
                    text += 'Up to $';
                }
                if (this.criteria.rate_max) {
                    if (this.criteria.rate_min) {
                        text += '-'
                    }
                    text += Number(this.criteria.rate_max).toFixed(0).toLocaleString();
                } else {
                    text += '+';
                }
                text += ' ' + this.criteria.rate_type;
            } else {
                text += 'Any price';
            }
            return text;
        },
        bedsBathsText() {
            let text = '';
            if (this.criteria.beds_min || this.criteria.beds_max) {
                if (this.criteria.beds_min) {
                    if (this.criteria.beds_max) {
                        text += this.criteria.beds_min + '-' + this.criteria.beds_max;
                    } else {
                        text += this.criteria.beds_min + '+';
                    }
                } else {
                    text += '1-' + this.criteria.beds_max;
                }
            } else {
                text += 'Any';
            }
            text += ' beds, '

            if (this.criteria.baths_min || this.criteria.baths_max) {
                if (this.criteria.baths_min) {
                    if (this.criteria.baths_max) {
                        text += this.criteria.baths_min + '-' + this.criteria.baths_max;
                    } else {
                        text += this.criteria.baths_min + '+';
                    }
                } else {
                    text += '1-' + this.criteria.baths_max;
                }
            } else {
                text += 'Any';
            }
            text += ' baths';

            return text;
        },
        keywordsText() {
            return '';
        },
        propertyCountText() {
            if (typeof this.nResults !== 'Number') {
                return '';
            }
            return this.nResults + ' properties';
        },
    },
    methods: {
        showForm() {
            this.$emit('show-search-form');
        },
    },
};
</script>

<style lang="scss">
.filterSummary {
    * {
        font-family: sans-serif;
    }

    .row1, .row2, .row3 {
        display: flex;
        gap: 10px;

        & > div {
            cursor: pointer;
        }
    }

    .where, .when, .who {
        border: 1px solid #101030;
        padding: 10px;

        h2 {
            text-transform: uppercase;
            font-weight: normal;
            font-size: 10pt;
            color: #3cacde;
            margin: 0 0 10px 0;
        }

        div, input {
            color: #101030;
            font-size: 12pt;
        }

        input {
            border: none;
        }
    }

    .row2 {
        margin-top: 10px;

        & > * {
            font-size: 12pt;
            cursor: pointer;
            line-height: 0;
            border-style: solid;
        }

        & > div {
            height: 0;
            border-radius: 30px;
            border-width: 15px;
            border-color: #101030;
            background-color: #101030;
            color: white;
        }

        & > input {
            height: 28px;
            border-radius: 30px;
            border-width: 1px;
            border-color: #101030;
            background-color: white;
            color: #101030;
            padding: 0 10px;
        }
    }

    .row3 {
        margin-top: 10px;
    }

    .propertyCount {
        text-transform: uppercase;
        font-weight: normal;
        font-size: 10pt;
        color: #3cacde;
        margin-left: 5px;
    }

    .notSet {
        opacity: 0.7;
    }
}
</style>